import { useContext } from 'react';
import { useTranslation } from 'react-i18next';
import { AccountStatusesEnum } from 'dash-common';
import {
  Box,
  Modal,
  ModalContext,
  Text,
  toast,
  useServerResponseTranslation,
} from 'dash-ui';

import { ExternalSalesModalKeys } from 'pages/external-sales/constants/constants';
import {
  GetSaleTeamUsersDocument,
  useSetSaleTeamUserStatusMutation,
} from 'gql/generated.graphql';

const SetSaleTeamUserStatusModal = () => {
  const { t } = useTranslation(['common', 'pages']);
  const { isOpenCurrent, toggleModal, setPayload, payload } =
    useContext(ModalContext);
  const isOpen = isOpenCurrent[ExternalSalesModalKeys.SetSaleTeamUserStatus];
  const translateServerResponse = useServerResponseTranslation();

  const isArchived = payload?.status === AccountStatusesEnum.ARCHIVED;

  const [setUserStatus] = useSetSaleTeamUserStatusMutation({
    refetchQueries: [GetSaleTeamUsersDocument],
  });

  const onRequestClose = () => {
    toggleModal(false, ExternalSalesModalKeys.SetSaleTeamUserStatus);
    setPayload(null);
  };

  const onSubmitRequest = () => {
    setUserStatus({
      variables: {
        status: payload?.status,
        saleTeamUserId: payload?.saleTeamUserId,
      },
      onCompleted: onRequestClose,
      onError: (error) => {
        toast.error(translateServerResponse(error));
      },
    });
  };

  return (
    <Modal
      title={
        (isArchived
          ? t('pages:organizationUsers.archiveUserModalTitle')
          : t('pages:organizationUsers.unarchiveUserModalTitle')) || ''
      }
      isOpen={isOpen}
      onRequestClose={onRequestClose}
      submitButton={{
        title: t('common:labels.submit'),
        onClick: onSubmitRequest,
      }}
      cancelButton={{
        title: t('common:labels.cancel'),
        onClick: onRequestClose,
      }}
    >
      <Box mt={2}>
        <Text>
          {isArchived
            ? t('pages:externalSalesPage.archiveUserText')
            : t('pages:externalSalesPage.unarchiveUserText')}
        </Text>
      </Box>
    </Modal>
  );
};

export default SetSaleTeamUserStatusModal;
